import React from 'react'
import { GuidesStyles } from './GuidesStyles'
import Text from '../../../../components/text/Text'

import { useNavigate } from 'react-router-dom'

interface DataType {
    image: string
    link: string
}

export function GuidesComponent() {
    const navigate = useNavigate()

    const handlerPress = (link: string) => {
        if (link) {
            window.open(link, '_blank')
        }
    }

    const data = [
        {
            image: require('../../../../assets/images/guide-1.png'),
            link: 'https://www.amipass.com/wordpress/wp-content/uploads/2024/07/Plantillas-RRSS.zip',
        },
        {
            image: require('../../../../assets/images/guide-2.png'),
            link: 'https://www.amipass.com/autocapacitacion-comercios/',
        },
        {
            image: require('../../../../assets/images/guide-3.png'),
            link: 'https://www.amipass.com/material-informativo-para-colaboradores/',
        },
    ]
    if (data.length === 0) return null

    return (
        <div style={GuidesStyles.container}>
            <Text
                label="Herramientas para tu empresa"
                marginBottom={15}
                fontWeight={400}
                color="#184287"
                fontSize={27}
            />
            <div style={GuidesStyles.content}>
                {data.map((item, index) => (
                    <button
                        key={index}
                        style={GuidesStyles.btnContent}
                        onClick={() => handlerPress(item.link)}
                    >
                        <img
                            src={item.image}
                            width={220}
                            height={181}
                            style={{ borderRadius: 8 }}
                        />
                    </button>
                ))}
            </div>
        </div>
    )
}
